import request from "../request";
import Url from "../url/qa";

const getQuestionAndAnswerList = ({ path = "", data, options = {} } = {}) => {
  return request.get(Url.getQuestionAndAnswerList + path, data, options);
};
const getQuestionAndAnswerDetails = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.get(Url.getQuestionAndAnswerDetails + path, data, options);
};
const setQuestionAndAnswer = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.setQuestionAndAnswer + path, data, options);
};
const updateQuestionAndAnswer = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.updateQuestionAndAnswer + path, data, options);
};
const deleteQuestionAndAnswer = ({ path = "", data, options = {} } = {}) => {
  return request.post(Url.deleteQuestionAndAnswer + path, data, options);
};
const updateQuestionAndAnswerOrders = ({
  path = "",
  data,
  options = {},
} = {}) => {
  return request.post(Url.updateQuestionAndAnswerOrders + path, data, options);
};

export default {
  getQuestionAndAnswerList,
  getQuestionAndAnswerDetails,
  setQuestionAndAnswer,
  updateQuestionAndAnswer,
  deleteQuestionAndAnswer,
  updateQuestionAndAnswerOrders,
};
